export default {
  MALE: 'mars', // 男生辨識圖
  FEMALE: 'venus', // 女生辨識圖
};
